import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
 
  detailsContainer: {
    marginBottom: 20,
    marginTop: 20,
  },
}));
